<template>
  <transition name="fade">
    <div
      class="card-block car-block"
      :class="{
        'card': mode === 'card',
        'inner': mode === 'inner' || mode === 'visit',
        'visit': mode === 'visit',
      }"
      v-if="car"
    >
      <div class="header">
        <div>
          <p
            class="car-model"
            v-if="carModel"
          >
            {{ carModel }}
          </p>
          <p
            class="car-engine"
            v-if="carEngine"
          >
            {{ carEngine }}
          </p>
        </div>
        <p
          class="car-vin-number"
          v-if="car.vin"
        >
          {{ car.vin.toUpperCase() }}
        </p>
        <p
          class="car-license-plate"
          v-if="car.licensePlate"
        >
          {{ car.licensePlate.toUpperCase() }}
        </p>
      </div>
      <div class="car-content">
        <img
          class="car-image"
          v-if="car.imgSrc"
          :src="car.imgSrc"
          alt=""
        >
      </div>
      <div
        class="car-footer"
        v-if="mode === 'card'"
      >
        <div class="next-visit">
          <p
            class="next-visit-date"
            v-if="nextVisitDate"
          >
            Zbliżająca się wizyta: <br>
            <span>
              {{ formatDate(nextVisitDate) }}
            </span>
          </p>
          <p v-else>
            Brak zbliżających się wizyt
          </p>
        </div>
      </div>
      <div
        class="controls-container"
        v-if="mode === 'card' || mode === 'inner'"
        :class="{ 'mobile' : isMobile }"
      >
        <button
          class="visit-control-button"
          v-if="mode === 'card'"
          @click="goTo(`/dashboard/visits/new/${carModelID}/station`, 'new_visit')"
          v-tooltip.left="{ content: 'Umów nową wizytę', classes: 'car-block-tooltip' }"
        >
          <svg class="icon" svg-inline="" role="presentation" focusable="false" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M9.5 17.5V21L7 23.5H4l-.5-.5L5 21.5l.5-1-2-2-1 .5L1 20.5.5 20v-3L3 14.5h3.5l8-8V3L17 .5h3l.5.5-1.8 1.7-.2.8 2 2 .8-.2L23 3.5l.5.5v3L21 9.5h-3.5z" stroke="currentColor" fill="none"/></svg>
        </button>
        <button
          class="visit-control-button"
          v-if="mode === 'card'"
          @click="goTo(`/dashboard/visits/next/${car.id}`, 'planned_visits')"
          v-tooltip.left="{ content: 'Zaplanowane wizyty', classes: 'car-block-tooltip' }"
        >
          <svg class="icon" svg-inline="" role="presentation" focusable="false" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M5.5 19.5v3c0 .6.4 1 1 1h15c.6 0 1-.4 1-1V6M.5 3v15.5c0 .5.4 1 1 1h12l5-5V3m0 11.5h-5v5M0 .5h19" stroke="currentColor"/><path d="M4 5.9l2.1-.5h.6v5.8h1.8v.8H4v-.8h1.8V6.3L4 6.7v-.8zm5.7 5.8v-.8c.7.2 1.5.3 2.3.4 1.4 0 2-.5 2-1.2 0-1.2-2.7-1.4-4.1-1.4l.2-3.3h4.5v.8h-3.7L10.8 8c1.9.1 4.1.5 4.1 2.1 0 1.1-.9 2-3 2-.8 0-1.5-.2-2.2-.4z" fill="currentColor" fill-rule="nonzero"/></g></svg>
        </button>
        <button
          class="visit-control-button"
          v-if="mode === 'card'"
          @click="goTo(`/dashboard/visits/history/${car.id}`, 'visit_history')"
          v-tooltip.left="{ content: 'Historia wizyt', classes: 'car-block-tooltip' }"
        >
          <svg class="icon" svg-inline="" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M11.5 4.5v8h5v-1h-4v-7z"/><path d="M12 .5C7.3.5 3.3 3.3 1.5 7.3V1.5h-1V9H8V8H2.3C3.9 4.2 7.6 1.5 12 1.5c5.8 0 10.5 4.7 10.5 10.5S17.8 22.5 12 22.5c-2.9 0-5.5-1.2-7.4-3.1l-.7.7c2.1 2.1 5 3.4 8.1 3.4 6.3 0 11.5-5.2 11.5-11.5S18.3.5 12 .5z"/></svg>
        </button>
        <button
          class="visit-control-button"
          v-if="mode === 'card'"
          @click="goTo(`/dashboard/carinfo/${car.id}`, 'car_info')"
          v-tooltip.left="{ content: 'Informacje o samochodzie', classes: 'car-block-tooltip' }"
        >
          <svg class="icon" svg-inline="" role="presentation" focusable="false" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M11.5 17v-7m0-2V6m0 16.5c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z" stroke="currentColor" fill="none"/></svg>
        </button>
        <button
          class="visit-control-button"
          v-if="mode === 'inner'"
          @click="deleteCarModal()"
          v-tooltip.left="{ content: 'Usuń samochód', classes: 'car-block-tooltip' }"
        >
          <svg svg-inline="" role="presentation" focusable="false" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M5.5 9v10.5c0 .5.4 1 1 1h10c.5 0 1-.5 1-1V9m-6-3.5v-2m-1.5 0h3m-9.5 4h16l-1.4-2H4.9l-1.4 2z" stroke="currentColor" fill="none"/></svg>
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ajax from '@/helpers/ajax';
import config from '@/config';
import dayjs from 'dayjs';
import maxBy from 'lodash/maxBy';

export default {
  props: {
    car: {
      default: () => {},
      type: Object,
    },
    mode: {
      default: 'card',
      type: String,
    },
  },
  computed: {
    ...mapGetters({
      primaryColor: 'brand/getPrimaryColor',
      thirdColor: 'brand/getThirdColor',
      allCars: 'brand/getSpecificModels',
    }),
    isMobile() {
      return this.$mq === 'mobile' || this.$mq === 'xs';
    },
    carModel() {
      const { brand, model } = this.car;
      if (brand && model) {
        return `${brand} ${model.toUpperCase()}`;
      }
      return '';
    },
    carEngine() {
      const {
        capacity, engine, power, transmission, quattro,
      } = this.car;
      if (capacity && engine && power && transmission) {
        if (quattro) {
          return `${capacity} ${engine.toUpperCase()} ${power} KW QUATTRO ${transmission.toUpperCase()}`;
        }
        return `${capacity} ${engine.toUpperCase()} ${power} KW ${transmission.toUpperCase()}`;
      }
      return '';
    },
    nextVisitDate() {
      const visitDates = this.car.visits.map(visit => ({
        status: visit.status,
        date: visit.date,
        diff: dayjs().diff(dayjs(visit.date)),
      })).filter(visit => visit.diff < 0 && visit.status !== 'Odwołana');
      const nextDate = maxBy(visitDates, visit => visit.diff);
      return nextDate !== undefined ? nextDate.date : null;
    },
    carModelID() {
      return this.allCars.find(carModel => carModel.name === this.car.name).id || null;
    },
  },
  methods: {
    ...mapActions({
      toggleModal: 'modal/openModal',
      closeModal: 'modal/closeModal',
      setModalContent: 'modal/setContent',
      setCallback: 'modal/setCallback',
      removeCar: 'myCars/removeCar',
      setModalStep: 'modal/setModalStep',
      setModalMode: 'modal/setModalMode',
      setSelectedLicensePlate: 'visit/setSelectedLicensePlate',
      setSelectedVin: 'visit/setSelectedVin',
      setShowHistoryVisits: 'visit/setShowHistoryVisits',
      setSelectedPartner: 'visit/setSelectedPartner',
      setSelectedServices: 'visit/setSelectedServices',
      setSelectedVisitDate: 'visit/setSelectedVisitDate',
      setRegisteredVisit: 'visit/setRegistered',
      setSelectedCarModelID: 'visit/setSelectedCarModelID',
      setMileage: 'visit/setMileage',
    }),
    formatDate(date) {
      return dayjs(date).format('DD-MM-YYYY hh:mm');
    },
    goTo(path, name) {
      if (name === 'new_visit') {
        this.resetVisitSpecs();
        this.setSelectedCarModelID(this.carModelID);
        this.setSelectedLicensePlate(this.car.licensePlate);
        this.setSelectedVin(this.car.vin);
      }
      if (name === 'planned_visits') {
        this.setShowHistoryVisits(false);
      }
      if (name === 'visit_history') {
        this.setShowHistoryVisits(true);
      }

      this.$router.push({ path });
    },
    deleteCar() {
      const endpoint = config.apiEndpoints.deleteCar.replace('id', this.car.id);

      ajax.delete(endpoint)
        .then((res) => {
          if (res.status === 200) {
            this.closeModal();
            this.removeCar(this.car.id);
            this.$router.push({ path: '/dashboard/mycars' });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    deleteCarModal() {
      this.setModalContent({
        title: 'Usuwanie samochodu',
        html: `
        <div class="remove-car">
          <br />
          <p class="modal-text">
            Czy na pewno chcesz dokonać usunięcia wybranego samochodu?
            <br><br>
            Uwaga: Akcja jest nieodwracalna.
            Utracisz wszystkie dane dotyczące usuwanego samochodu oraz historię wizyt,
            w tym również tych zbliżających się.
            Usunięcie samochodu nie spowoduje odwołania aktualnie zaplanowanych wizyt!
          </p>
        </div>
          `,
        confirm: 'Potwierdzam',
        cancel: 'Anuluj',
      });

      this.setCallback(this.deleteCar);
      this.toggleModal();
    },
    resetVisitSpecs() {
      this.setMileage(0);
      this.setSelectedPartner(null);
      this.setSelectedServices(null);
      this.setSelectedVisitDate(null);
      this.setRegisteredVisit(null);
    },
  },
};
</script>
